import React, { useState } from "react";
import "../releaseNote/releaseNote.css";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { FaChevronCircleDown, FaDivide, FaDownload } from "react-icons/fa";

const ReleaseNotes = () => {
  const [showv12Feature1, setShowv12Feature1] = useState(true);
  const [showv12Feature2, setShowv12Feature2] = useState(false);

  const searchDropdown = require("../../assets/images/searchDropdown.png");
  const bgLog = require("../../assets/images/bgLog.png");
  const alreadyrenewedBg = require("../../assets/images/alreadyRenewedBg.png");
  const initiateRenewal = require("../../assets/images/initiateRenewal.png");
  const newRenewed = require("../../assets/images/newRenewed.png");
  const renewed = require("../../assets/images/renewed.png");
  const renewedTable = require("../../assets/images/renewedTable.png");
  const renewModal = require("../../assets/images/renewModal.png");

  const toggleButtonOne = () => {
    setShowv12Feature1(!showv12Feature1);
  };

  const toggleButtonTwo = () => {
    setShowv12Feature2(!showv12Feature2);
  };

  return (
    <div className="release-notes mb-2">
      <div className="release-notes-content">
        <h1 className="title">Release Notes</h1>
        {/* <div className="flex-box">
        <img src={releaseNoteImg} />
      </div> */}
        <div className="mt-4 margin-bottom">
          <Accordion defaultActiveKey={["10"]} alwaysOpen>
            <Accordion.Item eventKey="10">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                29-May-2025
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v15
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Maximum File Upload Size increased to 4 MB
                      </strong>{" "}
                    </span>

                    <div className="feature-one-heading mt-2">
                      The Maximum file upload size provided in the application
                      was 2 MB. To accommodate scenarios where BGs with digital
                      signatures go beyond this size, the maximum file upload
                      size has been increased to 4 MB.
                    </div>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="0">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                09-Jan-2025
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v14
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Scanning of Uploaded File for protection from Malware{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        An antivirus and antimalware solution has been built in
                        to indicate files that are virus infected.
                      </li>
                      <li className="releaseList">
                        A few minutes after the file is uploaded in the BG app,
                        the user can reload the page to know the status of the
                        uploaded file.
                      </li>

                      <li className="releaseList">
                        If the Download icon of the uploaded file is greyed out,
                        it indicates the file is virus infected and hence it
                        cannot be downloaded, while if the Download icon is in
                        green color, it indicates the file is clean and is safe
                        to be downloaded.
                      </li>
                      <li className="releaseList">
                        A note explaining this behavior has been added to the
                        bottom of the page.
                      </li>
                    </ul>
                    <span className="feature-one-heading">
                      <strong>
                        Note: The uploaded file will be scanned . A greyed-out
                        download icon {"( "}
                        <span
                          style={{
                            color: "grey",
                          }}
                        >
                          <FaDownload />
                        </span>
                        {" ) "}
                        indicates that the file is infected and cannot be
                        downloaded. A green download icon {"( "}
                        <span
                          style={{
                            color: "green",
                          }}
                        >
                          <FaDownload />
                        </span>
                        {" ) "}
                        indicates that the file is clean and can be safely
                        downloaded.{" "}
                      </strong>
                    </span>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                20-Nov-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v13
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>
                  {showv12Feature1 && (
                    <>
                      <span className="feature-one-heading">
                        <strong>Renewal of BG </strong>
                      </span>
                      <ul className="mt-2 font-size">
                        <li>
                          <div>
                            When the BG is with the customer, the Requestor from
                            the Branch is provided with an option to Initiate a
                            renewal of the BG. From 90 days prior to the expiry
                            of the BG (Validity To Date ) the{" "}
                            <strong>Initiate Renewal</strong>
                            button would be made available to the Requestor as
                            shown below{" "}
                          </div>
                          <div className="flex-box">
                            <img
                              src={initiateRenewal}
                              className="wage-mapping-img"
                            />
                          </div>
                        </li>
                        <li>
                          <div>
                            On the click of the{" "}
                            <strong>Initiate Renewal</strong> button, the below
                            pop-up will appear. The extended Validity Date and
                            Claim Period must be provided in the
                            <strong>Renew Validity To</strong> and{" "}
                            <strong> Renew Claim period</strong> fields to Renew
                            the BG. The <strong>Renew button</strong> is
                            provided for the same.
                          </div>
                          <div className="flex-box">
                            <img
                              src={renewModal}
                              className="wage-mapping-img"
                            />
                          </div>
                        </li>
                        <li>
                          <div>
                            On the click of the Renew button, the message below
                            would be displayed to indicate successful renewal of
                            the BG . A new request is created to track this
                            renewal process. The new Req ID is provided in the
                            message to enable the user to proceed with the next
                            steps. This request would be the listed last in the
                            Request drop down upon click of the Fetch button in
                            the homepage
                          </div>
                          <div className="flex-box">
                            <img src={renewed} className="wage-mapping-img" />
                          </div>
                        </li>
                        <li>
                          The <strong>Validity From</strong> of the new request
                          would be the next day of the Validity To of the old
                          request to indicate the extension of the BG.{" "}
                        </li>
                        <li>
                          The new request will follow the same process of
                          –Approval, Application to Bank, Receival from bank,
                          handover to branch and submission to customer.{" "}
                        </li>
                        <li>
                          <div>
                            {" "}
                            Once the renewed BG is handed over to the branch for
                            submission to customer. the old request will be
                            moved to the Renewed section as shown below{" "}
                          </div>{" "}
                          <div className="flex-box">
                            <img
                              src={renewedTable}
                              className="wage-mapping-img"
                            />
                          </div>
                        </li>
                        <li>
                          <div>
                            To help the user differentiate the old and new
                            requests , the old requests are colored in green as
                            shown till they move to the Renewed section{" "}
                          </div>
                          <div className="flex-box">
                            <img
                              src={newRenewed}
                              className="wage-mapping-img"
                            />
                          </div>
                        </li>
                        <li>
                          <div>
                            {" "}
                            Also, a Note as shown below (in red) would be
                            displayed in the old request to indicate no more
                            actions can be taken in this and the new request
                            mentioned is to be referred.{" "}
                          </div>{" "}
                          <div className="flex-box">
                            <img
                              src={alreadyrenewedBg}
                              className="wage-mapping-img"
                            />
                          </div>
                        </li>
                      </ul>
                    </>
                  )}
                </div>
                <div>
                  <h3 className="feature-heading"> Feature #2</h3>
                  <div>
                    The file names of the files to be uploaded can have a dot in
                    the file name. Since most of the PO, SOs are named with
                    dates in them, this change has been provided.{" "}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                26-Sep-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v12
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>
                  {showv12Feature1 && (
                    <>
                      <span className="feature-one-heading">
                        The <strong> Date of application </strong> has been
                        validated to be greater than or equal to the{" "}
                        <strong>Request creation date</strong> . This is to
                        accommodate scenarios where the application date can be
                        on the same date of request by branch/customer.
                      </span>
                    </>
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                25-Jun-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v11
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>
                  {showv12Feature1 && (
                    <>
                      <span className="feature-one-heading">
                        A <strong>search option </strong> is provided in the
                        customer's name drop down as shown below to enable ease
                        of selection
                      </span>

                      <div className="flex-box">
                        <img
                          src={searchDropdown}
                          className="wage-mapping-img"
                        />
                      </div>
                    </>
                  )}
                </div>
                <div>
                  <h3 className="feature-heading"> Feature #2</h3>
                  <strong>
                    The Stage names have been updated as below to enable ease of
                    understanding for users
                  </strong>
                  <ul className="mt-2 font-size">
                    <li>
                      <strong>Approval : to Sent for Approval </strong>
                    </li>
                    <li>
                      <strong>Acknowledge : to Approved </strong>
                    </li>
                  </ul>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                12-Mar-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v10
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <div className="font-bold">
                    While uploading a document, if the file name contains a dot
                    (.) in it, an error message “ File Type not permitted” would
                    be displayed.
                  </div>
                  <div className="font-bold mt-2">
                    User is requested to remove the dot in the file name and
                    rename and upload the file.{" "}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                07-Mar-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v9
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <div className="font-bold">
                    Login Screen FIx for Mobile Login of BG App{" "}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                05-Mar-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v8
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>
                  <div className="font-bold">
                    Google Analytics and Security Audit Changes ( Technical
                    Changes){" "}
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                11-Jan-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v7
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <div>E-mail Alert </div>
                  <ul className="mt-2 font-size">
                    <li>
                      E-mail alerts would be sent to the Requestors, Approvers
                      and Finance users of the application for their attention
                      and action in stages where they are involved. As the
                      request progresses stage by stage, the user who was
                      involved and the user who is going to be involved will be
                      intimated to keep the process clear and transparent.
                      <div>
                        {" "}
                        <Table striped bordered hover className="mt-2">
                          <thead>
                            <tr>
                              <th>S. No </th>
                              <th>Process/Stage </th>
                              <th>Mail Recipients </th>
                              <th>Remarks </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>Request Creator</td>
                              <td></td>
                              <td className="width-td"></td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>Request sent for Approval</td>
                              <td>
                                To: Approver <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Approval Pending Mail Alert <br /> An FYI
                              </td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>Request Approved</td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>
                                Finance Acknowledges the request and moves it to
                                Draft to Bank stage
                              </td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>
                                Finance moves the request from Draft to Bank to
                                Applied Stage
                              </td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>6</td>
                              <td>
                                Finance moves the request and moves it to
                                Applied to Receive from Bank stage
                              </td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>7</td>
                              <td>
                                Finance moves the request from Received from
                                Bank to the Requestor (Customer stage)
                              </td>
                              <td>
                                To: Requestor <br />
                                Cc: Finance
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>8</td>
                              <td>
                                Requestor moves the request from Customer to
                                Submitted for closure
                              </td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td>9</td>
                              <td>
                                Finance moves the request from Submitted for
                                Closure to Surrendered stage
                              </td>
                              <td>
                                To: Finance <br />
                                Cc: Requestor
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>10</td>
                              <td>Request Rejected by Approver</td>
                              <td>To: Requestor</td>
                              <td>Attention/Action Required Mail Alert</td>
                            </tr>
                            <tr>
                              <td>11</td>
                              <td>Request Rejected by Finance</td>
                              <td>
                                To: Requestor <br />
                                Cc: Finance
                              </td>
                              <td>
                                Attention/Action Required Mail Alert <br /> An
                                FYI
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="8">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                20-Dec-2023
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v6
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>
                  <div className="font-bold">
                    <strong>
                      {" "}
                      Applied option provided along with Draft to bank{" "}
                    </strong>
                  </div>

                  <div className="mt-2">
                    In the Acknowledge Stage for the Finance, The Applied option
                    is now provided along with the Draft to bank, in the Status
                    drop down to address scenarios where a draft is not required
                    (like in EMD etc).{" "}
                  </div>

                  <div className="mt-2">
                    <h3 className="feature-heading"> Feature #2</h3>
                    <div className="font-bold">
                      <strong> Chronological Order of Log </strong>
                    </div>
                    <div className="mt-2">
                      The log details provided for every request is now in the
                      chronological order of the actions ( Moving it to a
                      section in the Request details modal will be made
                      available in the next version.{" "}
                    </div>
                  </div>
                  <div className="mt-2">
                    <h3 className="feature-heading"> Feature #3</h3>
                    <div className="font-bold">
                      <strong> Customer Handover Date Change </strong>
                    </div>
                    <div className="mt-2">
                      The Customer Handover Date is captured in the Requestor
                      Role after the finance has sent it back to them (after
                      Receiving from the bank) .{" "}
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="9">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                03-Nov-2023
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                BG Go- Live
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>
                  <div className="font-bold">
                    <strong> BG Business Flow </strong>
                  </div>

                  <div className="mt-2">
                    Complete business flow from creating a request for a BG ,
                    approval and all stages involved in the finance process .{" "}
                  </div>

                  <div className="mt-2">
                    <h3 className="feature-heading"> Feature #2</h3>
                    <div className="font-bold">
                      <strong> Document Upload and Download </strong>
                    </div>
                    <div className="mt-2">
                      <ul>
                        <li>Option to upload and download documents.</li>
                        <li>
                          Option for uploaders to only remove /delete their
                          documents.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mt-2">
                    <h3 className="feature-heading"> Feature #3</h3>
                    <div className="font-bold">
                      <strong> Summary Tab </strong>
                    </div>
                    <div className="mt-2">
                      The Summary of all the active BGs at that given point in
                      time provides the values of the BG's in pre claim period,
                      BG's in claim period, BG's after claim period and total BG
                      value for all the issuing banks.{" "}
                    </div>
                  </div>
                  <div className="mt-2">
                    <h3 className="feature-heading"> Feature #4</h3>
                    <div className="font-bold">
                      <strong> Log Details </strong>
                    </div>
                    <div className="mt-2">
                      Log Details for every request opens upon click of the (+)
                      sign to the left of every request to provide details on
                      the actions and status changes triggered by the user along
                      with the date and time as shown below{" "}
                    </div>
                    <div className="flex-box">
                      <img src={bgLog} className="wage-mapping-img" />
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReleaseNotes;
